<!-- Tarjeta -->
<div *ngIf="model">
    <div class="pb-3">
        <div class="d-flex align-items-center justify-content-between px-4">
            <div class="w-100">
                <input type="range" class="form-control-range" [(ngModel)]="pointsSelected" [max]="user.availablePoints" 
                (input)="onUpdatePoints($event)">
                <div class="d-flex justify-content-between">
                    <div class="text-muted">0</div>
                    <div class="text-muted">{{user.availablePoints}}</div>
                </div>
            </div>
        </div>
        
        <div class="text-left d-flex px-4">
            <div class="d-flex align-items-center w-100">
                <span class="font-14">Cantidad de puntos:</span>
                <input type="number" class="form-control ml-5"
                    [value]="pointsSelected" (input)="onUpdatePoints($event)"  
                    (blur)="onValidatePointsInput($event)" style="width: 70px; height: 50px !important; border-radius: 5px;">
                <div class="input-group-append ml-1" style="display: flex; align-items: center;">
                    <span style="vertical-align: middle;">PTS</span>
                </div>
            </div> 
        </div>
        <div *ngIf="exceededPointsFlag" class="text-left d-flex px-4  font-12 " style="color: #FE574E;">
            La cantidad de puntos seleccionados exceden el máximo permitido por compra.
        </div>
    </div>

    <!-- <div class="d-flex align-items-center justify-content-between">

    LOGO 
        <div class="text-left">
            <img class="m-5-5" src="{{currentMethod.logoURL}}" width="36"> 

            <div>
                <span class="m-r-10 font-14">Puntos disponibles:</span>
                <span class="font-bold">{{user.availablePoints}} pts</span>
            </div>
        </div>

        <button class="btn btn-tag-primary" (click)="onOpen(purchaseModal)">Aplicar puntos</button>
    </div>-->
</div>


<!-- Opciones de pago -->
<ng-template #purchaseModal let-modal>
    <div class="modal-body">
        <div>
            <button class="close" (click)="modal.dismiss()">
                <i class="fa fa-times m-t-5 m-r-10"></i>
            </button>
        </div>

        <div class="border-bottom">
            <div class="text-center">
                <i class="mdi mdi-credit-card-multiple mdi-24px"></i>
            </div>
            <div class="text-center m-b-20">
                Pago con puntos
            </div>
        </div>


        <div class="d-flex flex-row justify-content-between border-bottom p-t-20 p-b-20">
            <span>Puntos disponibles:</span>
            <span class="font-bold">{{user.availablePoints}} pts</span>
        </div>

        <div class="d-flex flex-row justify-content-between border-bottom p-t-20 p-b-20">
            <span>Puntos a utilizar:</span>
            <span class="font-bold">{{model.points}} pts</span>
        </div>

        <div class="d-flex flex-row justify-content-between border-bottom p-t-20 p-b-20">
            <span>Descuento</span>
            <span class="font-bold">
                {{model.pointsCash | currency: currencySymbol : 'symbol': '0.0'}}
            </span>
        </div>

    </div>
</ng-template>